<div class="d-flex flex-column justify-content-center">
  <div class="d-flex flex-column extra-padding justify-content-center">
    <div class="title">
      <span>You don't have an active subscription yet.</span>
      <span>Interested in using Blue.GDPR?</span>
    </div>
    <a class="active" href="mailto:contact@theblue.ai">Contact us</a>
  </div>

  <div class="bottom-row">
    <a [routerLink]="['/login']">Logout</a>
  </div>
</div>
